export const generalTypes = {
    changeView: '[general] change view mode',
    infoToEdit: '[general] set filter info',
    loading:'[general] change loading state',
    clearState : '[general] clear state',
    dataToEdit : '[general] set data to edit',
    langsInData: '[general] set langs values',
    enabledForm: '[general] enabled form',
    editMode:'[general] change editMode status',
}

export const mainActionTypes = {
    app         : '[Main] Selected Menu App',
    module      : '[Main] Selected Module',
    udn         : '[Main] Selected UDN',
    menu        : '[Main] Selected menu',
    category    : '[Main] Control category',
    parent      : '[Main] Parent model of the selected object ',
    view        : '[Main] Set view mode',
    mapConfig   : '[Main] Configuration for map ',
    userIsAdmin   : '[Main] Identify if user is admin ',
    clearState  : '[Main] Clear state',
    loading     : '[Main] Change loading state',
}

export const formActionTypes = {
    clearState      : '[FormProps] Clear state',
    resetCombos     : '[FormProps] Reset dropdown boxes',
    domainObject    : '[FormProps] Selected Object/Item',
    formData        : '[FormProps] Set the form behavior',
    langs           : '[FormProps] Set the langs of the object',
    secondaryLangs  : '[FormProps] Set the secondary langs of the object',
}

export const listActionTypes = {
    clearState          : '[ListProps] Clear state',
    tableParams         : '[ListProps] Reset dropdown boxes',
    listDomainObjects   : '[ListProps] List of object/items old',
    filter              : '[ListProps] Search filter params',
    addItem             : '[ListProps] Add item to list',
    removeItem          : '[ListProps] Remove item from list',
    changeItem          : '[ListProps] Change list item if edited',
    reload              : '[ListProps] Reload items',
}

export const childActionTypes = {
    clearState          : '[ChildProps] Clear state',
    resetCombos         : '[ChildProps] Reset dropdown boxes',
    childObject        : '[ChildProps] Selected Object/Item',
    formData            : '[ChildProps] Set the form behavior',
    langs               : '[ChildProps] Set the langs of the object',
    tableParams         : '[ChildProps] Reset dropdown boxes',
    listDomainObjects   : '[ChildProps] List of object/items',
    filter              : '[ChildProps] Search filter params',
    addItem             : '[ChildProps] Add item to list',
    removeItem          : '[ChildProps] Remove item from list',
    changeItem          : '[ChildProps] Change list item if edited',
    showModal           : '[ChildProps] Show/hide modal',
    loading             : '[ChildProps] Change loading state',
}

export const langTypes = {
    register: '[lang] register langs',
    clearLangs: '[lang] clear langs info',
}

export const filterTypes = {
    items: '[filter] register items info',
    filter:'[filter] register the filter info',
    tableInfo:'[filter] register table info',
    clear:'[filter] clear filter info',
    loadData:'[filter] change load data status',
    addItem:'[filter] add item to list',
    removeItem: '[filter] remove item from list',
    changeItem:'[filter] change list item',
}

export const selectorsTypes = {
    registerSupervisors:'[selectors] register supervisors info',
    addSupervisors:'[selectors] add supervisor to list',
    removeSupervisors:'[selectors] remove supervisor from list',
    clearSupervisors:'[selectors] clear supervisor list',
}